










































































































































import {Emit} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';
import {Achat} from '@/models';

import storeAchat from '@/stores/modules/achat';

import CrudTransporteurSearch from "@/components/Crud/Transporteur/Search.vue";
import CrudClientSearch from "@/components/Crud/Client/Search.vue";
import CrudLongueursAchatSearch from "@/components/Crud/LongueursAchat/Search.vue";
import CrudBoisTypeSearch from "@/components/Crud/BoisType/Search.vue";
import InputBoisType from "@/components/Input/BoisType.vue";
import InputLongueursAchat from "@/components/Input/LongueursAchat.vue";
import InputDatePicker from "@/components/Input/DatePicker.vue";

@Component({
	components: {
		CrudTransporteurSearch,
		CrudClientSearch,
		CrudLongueursAchatSearch,
		CrudBoisTypeSearch,
		InputBoisType,
		InputLongueursAchat,
		InputDatePicker,
	}
})
export default class CrudAchatGeneralEdit extends AbstractEditVue<Achat> {

	// DF: utiliser pour la création d'un achat uniquement
	// en modification on passe par la light
	private step: number = 1;

	public constructor() {
		super(
			storeAchat,
			'Achat modifié',
			'Achat créé',
		);
	}

//	@Emit()
//	private onNext() {
//		if ((!this.item.address) || (this.item.address === null) )
//		{
//			this.item.address = this.item.name;
//		}
//		this.step = 2;
//	}

	protected async onSubmit(): Promise<void> {
		super.onSubmit();
		this.step = 1;
	}

	public async mounted(): Promise<void> {
		await super.mounted();
	}

	public async refresh(): Promise<void> {
		await super.refresh();
		//console.log('route achat edit = ' + this.$route.name);
		if (this.$route.name === 'achat-edit') {
			this.$route.meta.title = 'Modification  d\'un achat';
		}
	}

}
